function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import Evented from './Evented';
import metrics from './sharedMetrics';
import LongPollTransport from './transport/LongPollTransport';
import WebSocketTransport from './transport/WebSocketTransport';
var RETRY_DELAY = 5000;

function longPollParams(subscriptions) {
  // Firehose doesn't like true JSON, it wants numbers to be numbers
  var params = [];
  subscriptions.forEach(function (item) {
    params.push("\"" + item.channelPath + "\": " + (item.lastMessageSequence || 0));
  });
  return "{" + params.join(',') + "}";
}

function getParams(options) {
  return typeof options.params === 'function' ? options.params() : options.params || {};
}

function subscribeMessage(channel) {
  return {
    multiplex_subscribe: {
      channel: channel.channelPath,
      message_sequence: channel.lastMessageSequence,
      params: getParams(channel.options)
    }
  };
}
/**
 * Core 'channel' connection to firehose, without multiplexing
 * used by host channel as the common connection
 */


var HostChannel = /*#__PURE__*/function (_Evented) {
  _inheritsLoose(HostChannel, _Evented);

  function HostChannel(channelPath, options) {
    var _this;

    _this = _Evented.call(this) || this;
    _this.triedLongPoll = false;
    _this.internalIsConnected = false;
    _this.isReconnecting = false;
    _this.subscribedTo = [];
    _this.channelPath = channelPath;
    _this.options = options;

    _this.options.params = function () {
      if (_this.transport instanceof WebSocketTransport) {
        return {};
      } else {
        return longPollParams(_this.subscribedTo);
      }
    };

    _this.transport = _this.startTransport(WebSocketTransport);
    metrics.registerHost(_assertThisInitialized(_this), _this.options);
    return _this;
  }

  var _proto = HostChannel.prototype;

  _proto.subscribeToChannel = function subscribeToChannel(channel) {
    this.subscribedTo.push(channel);

    if (this.transport instanceof WebSocketTransport) {
      this.transport.sendMessage(subscribeMessage(channel));
    } else {
      this.transport.stop();
      this.transport.start();
    }
  };

  _proto.unsubscribeFromChannel = function unsubscribeFromChannel(channel) {
    this.subscribedTo = this.subscribedTo.filter(function (item) {
      return item !== channel;
    });

    if (this.transport instanceof WebSocketTransport) {
      this.transport.sendMessage({
        multiplex_unsubscribe: [channel.channelPath]
      });
    } else {
      this.transport.stop();

      if (this.subscribedTo.length) {
        this.transport.start();
      }
    }
  };

  _proto.listenToTransport = function listenToTransport() {
    var _this2 = this;

    this.listenTo(this.transport, 'message', function (msg, frame) {
      _this2.heartbeat();

      if (msg && msg.error != null) {
        _this2.emit('error', msg.error, frame);
      } else {
        _this2.emit('message', msg, frame);
      }
    });
    this.listenTo(this.transport, 'failed', function (reason) {
      if (reason === 'connection') {
        if (!_this2.triedLongPoll) {
          _this2.emit('switching', 'long-poll');

          _this2.switchToLongPoll();
        } else {
          _this2.resetAndRetry();
        }
      } else {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        _this2.emit.apply(_this2, ['failed', reason].concat(args));
      }
    });
    this.listenTo(this.transport, 'connected', function () {
      return _this2.emit('connected');
    });
    this.listenTo(this.transport, 'reconnecting', function () {
      _this2.isReconnecting = true;

      _this2.emit('reconnecting');
    });
    this.listenTo(this.transport, 'up', function () {
      if (_this2.isReconnecting) {
        _this2.resubscribeToChannels();

        _this2.isReconnecting = false;
      }

      _this2.internalIsConnected = true;
      _this2.lastConnected = new Date();
      _this2.lastHeartbeat = new Date();

      _this2.emit('up');
    });
    this.listenTo(this.transport, 'down', function () {
      _this2.internalIsConnected = false;

      _this2.emit('down');
    });
    this.listenTo(this.transport, 'heartbeat', function () {
      return _this2.heartbeat();
    });
  };

  _proto.startTransport = function startTransport(Transport) {
    this.transport = new Transport(this.channelPath, this.options);
    this.listenToTransport(); // We want the WebSocket open always, LongPoll needs something to subscribe to

    if (this.subscribedTo.length || this.transport instanceof WebSocketTransport) {
      this.transport.start();
    }

    return this.transport;
  };

  _proto.switchToLongPoll = function switchToLongPoll() {
    this.triedLongPoll = true;
    this.transport.stop();
    this.stopListening();
    this.startTransport(LongPollTransport);
  };

  _proto.resetAndRetry = function resetAndRetry() {
    var _this3 = this;

    this.triedLongPoll = false;
    this.internalIsConnected = false;
    this.transport.stop();
    this.stopListening();
    this.emit('down');
    setTimeout(function () {
      _this3.isReconnecting = true;

      _this3.emit('reconnecting');

      _this3.startTransport(WebSocketTransport);
    }, RETRY_DELAY);
  };

  _proto.resubscribeToChannels = function resubscribeToChannels() {
    var _this4 = this;

    if (this.transport instanceof WebSocketTransport) {
      this.subscribedTo.forEach(function (channel) {
        _this4.transport.sendMessage(subscribeMessage(channel));
      });
    }
  };

  _proto.heartbeat = function heartbeat() {
    var _this5 = this;

    this.lastHeartbeat = new Date();
    setTimeout(function () {
      return _this5.emit('heartbeat');
    }, 0);
  };

  _createClass(HostChannel, [{
    key: "isConnected",
    get: function get() {
      return this.internalIsConnected;
    }
  }, {
    key: "metrics",
    get: function get() {
      return {
        connected: this.internalIsConnected,
        reconnecting: this.isReconnecting,
        lastConnected: this.lastConnected,
        lastHeartbeat: this.lastHeartbeat,
        transport: this.transport instanceof WebSocketTransport ? 'websocket' : 'longpoll',
        channels: this.subscribedTo.map(function (channel) {
          return channel.metrics;
        })
      };
    }
  }]);

  return HostChannel;
}(Evented);

export { HostChannel as default };